import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContactUsModel } from '../components/contactus/contactusmodel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactusService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  createEnquiry(contactusmodel:ContactUsModel):Observable<any>
  {
    return this.http.post<any>(this.apiUrl+'contactus/createEnquiry',contactusmodel);
  }
}
